var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoDfinity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 906 642",
    style: {
      enableBackground: "new 0 0 906 642"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:url(#Path-9_1_);}\n\t.st2{fill:url(#Path-12_1_);}\n\t.st3{fill:#29ABE2;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "dfinity_logo"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M109.2,443.6H90.3c-2.7-0.2-5.1,1.8-5.3,4.5c0,0.2,0,0.5,0,0.7v61.7c-0.3,2.7,1.7,5.1,4.4,5.4 c0.3,0,0.6,0,0.9,0h18.9c21.7,0,37-14.7,37-36.1S131.1,443.6,109.2,443.6z M132.2,479.7c0.8,12.5-8.7,23.3-21.2,24.1 c-0.7,0-1.3,0.1-2,0H98.8v-48.3H109c12.5-0.4,22.9,9.4,23.2,21.9C132.3,478.2,132.3,478.9,132.2,479.7L132.2,479.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M251.1,443.6h-37c-2.8-0.2-5.1,1.9-5.3,4.7c0,0.2,0,0.4,0,0.6v61.7c-0.2,2.7,1.8,5.1,4.5,5.3c0.3,0,0.5,0,0.8,0 h3.4c2.7,0.2,5.1-1.8,5.3-4.5c0-0.3,0-0.5,0-0.8v-24.2H247c1.4,0.1,2.8-0.4,3.8-1.4c1-1,1.5-2.4,1.4-3.8v-1.1 c0.2-2.7-1.8-5.1-4.5-5.3c-0.2,0-0.5,0-0.7,0h-24.4v-18.8h28.5c2.8,0.2,5.1-1.9,5.3-4.7c0-0.2,0-0.4,0-0.6v-1.3 C256.2,445.6,254.3,443.6,251.1,443.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M338.2,443.6h-3.4c-2.7-0.2-5.1,1.8-5.3,4.6c0,0.2,0,0.5,0,0.7v61.7c-0.3,2.7,1.6,5.1,4.3,5.4c0.3,0,0.7,0,1,0 h3.4c2.7,0.2,5.1-1.8,5.3-4.5c0-0.3,0-0.5,0-0.8v-61.8c0.2-2.8-1.9-5.1-4.7-5.3C338.7,443.5,338.5,443.5,338.2,443.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M470.3,443.6h-3.5c-2.7-0.2-5.1,1.8-5.3,4.6c0,0.2,0,0.5,0,0.7v41.1l-32.2-43.3c-1.3-1.8-3.5-2.9-5.7-2.8h-1.4 c-2.8-0.2-5.1,1.9-5.3,4.6c0,0.2,0,0.5,0,0.7v61.5c-0.2,2.8,1.9,5.1,4.7,5.3c0.2,0,0.4,0,0.7,0h3.4c2.8,0.2,5.1-1.9,5.3-4.7 c0-0.2,0-0.4,0-0.7v-41.4l32.2,43.7c1.3,1.8,3.5,2.8,5.8,2.7h1.4c2.7,0.2,5.1-1.8,5.3-4.6c0-0.2,0-0.5,0-0.7v-61.6 c0.2-2.7-1.9-5.1-4.6-5.3C470.8,443.5,470.6,443.5,470.3,443.6L470.3,443.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M557.5,443.6h-3.2c-2.7-0.2-5.1,1.8-5.3,4.6c0,0.2,0,0.5,0,0.7v61.7c-0.2,2.7,1.8,5.1,4.6,5.3 c0.2,0,0.5,0,0.7,0h3.5c2.7,0.2,5.1-1.8,5.3-4.6c0-0.2,0-0.5,0-0.7v-61.7c0-2.9-2.3-5.3-5.2-5.3 C557.7,443.6,557.6,443.6,557.5,443.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M690.2,443.6h-48.8c-2.7-0.2-5.1,1.8-5.3,4.6c0,0.2,0,0.5,0,0.7v1.4c-0.2,2.7,1.8,5.1,4.5,5.3 c0.3,0,0.5,0,0.8,0h17.3v55c-0.2,2.7,1.8,5.1,4.5,5.3c0.3,0,0.5,0,0.8,0h3.2c2.7,0.2,5.1-1.8,5.3-4.5c0-0.3,0-0.5,0-0.8v-55h17.3 c2.7,0.2,5.1-1.8,5.3-4.6c0-0.2,0-0.5,0-0.7v-1.4c0.2-2.7-1.9-5.1-4.6-5.3C690.4,443.6,690.3,443.6,690.2,443.6L690.2,443.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M820.6,445.8c-0.9-1.5-2.6-2.3-4.3-2.1h-4.3c-2.4-0.1-4.6,1.2-5.8,3.2l-17,27.2l-16.8-26.9 c-1.1-2.1-3.4-3.4-5.8-3.2h-4.3c-1.7-0.1-3.3,0.7-4.3,2.1c-0.8,1.6-0.5,3.5,0.7,4.8l23.7,35.7v24.1c-0.2,2.7,1.8,5.1,4.5,5.3 c0.3,0,0.5,0,0.8,0h3.2c2.7,0.2,5.1-1.8,5.3-4.5c0-0.3,0-0.5,0-0.8v-24.1l23.5-35.7C821.5,448.2,821,446.6,820.6,445.8z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    className: "st0",
    d: "M662.3,248.7c-0.5-41.3-34.4-74.3-75.7-73.8c-11,0-30.6,5.5-60.3,31.5 c-14.1,12.7-27.4,26.4-39.5,41c16.3,17.3,33.8,35.4,41.8,42.3c15.4,12.7,32.4,23.4,50.6,31.7c2.4,0.6,4.9,0.9,7.4,1 C628.3,322.3,662.3,289.2,662.3,248.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    className: "st0",
    d: "M527.8,290.8c24.6,21.4,41.2,28.5,51.5,30.8c2.4,0.6,4.9,0.9,7.4,1c41.9-0.3,75.7-33.4,75.7-73.9 c-0.5-41.3-34.4-74.3-75.7-73.8c-11,0-30.6,5.5-60.3,31.5c-14.1,12.7-27.4,26.5-39.5,41.1C499.5,262.9,513.2,277.3,527.8,290.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path-9_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 157.4654,
    y1: -276.1594,
    x2: 160.3154,
    y2: -273.8294,
    gradientTransform: "matrix(60.08 0 0 47.2 -8937.3203 13207.999)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#F15A24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    style: {
      stopColor: "#FBB03B"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path-9",
    className: "st1",
    d: "M586.7,126.3c-29,0-60.6,15-94.1,44.2C478.4,183,465.2,196.5,453,211l0,0c0,0,16.3,17.7,34.3,36.6 c12-14.7,25.2-28.5,39.3-41.2c29.7-26,49.2-31.5,60.3-31.5c41.3-0.5,75.2,32.5,75.7,73.8c0,40.5-34.1,73.6-75.7,73.9 c-2.5-0.1-5-0.4-7.4-1c11.8,5.5,24.7,8.6,37.7,9c76.6,0,91.5-49.9,92.5-53.5c2.3-9.3,3.4-18.9,3.4-28.5 C712.8,181.1,656.2,126.3,586.7,126.3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path-10",
    className: "st0",
    d: "M244,248.7c0.5,41.3,34.4,74.3,75.7,73.9c11,0,30.6-5.5,60.3-31.5c14.2-12.8,27.4-26.5,39.6-41.2 c-16.3-17.3-33.8-35.5-41.9-42.3c-15.4-12.8-32.4-23.4-50.7-31.7c-2.4-0.6-4.9-0.9-7.4-0.9C277.8,175.4,244,208.5,244,248.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path-11",
    className: "st0",
    d: "M378.3,206.9c-24.6-21.4-41.2-28.5-51.5-30.8c-2.4-0.6-4.9-0.9-7.4-0.9 c-40.8-0.9-74.6,31.3-75.6,72.1c-0.9,40.8,31.3,74.6,72.1,75.6c1.1,0,2.3,0,3.4,0c11,0,30.6-5.5,60.3-31.5 c14.2-12.8,27.4-26.5,39.6-41.2c0.3-0.3,0.5-0.6,0.7-0.9C407.1,234.1,393.2,220,378.3,206.9L378.3,206.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Path-12_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.1365,
    y1: -273.1602,
    x2: 153.2765,
    y2: -275.4902,
    gradientTransform: "matrix(60.09 0 0 47.23 -8998.8398 13225.8301)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#ED1E79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    style: {
      stopColor: "#522785"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path-12",
    className: "st2",
    d: "M319.6,371.6c29,0,60.6-14.9,94.1-44.2c14.3-12.6,27.5-26.2,39.8-40.7l0,0 c0,0-16.3-17.7-34.2-36.6c-12.1,14.7-25.4,28.5-39.6,41.2c-29.7,26-49.2,31.5-60.3,31.5c-41.3,0.5-75.2-32.5-75.7-73.8 c0-40.5,34-73.6,75.7-73.8c2.5,0,4.9,0.3,7.4,0.9c-11.9-5.5-24.7-8.6-37.8-9c-76.3,0-91.3,49.7-92.2,53.4 c-2.3,9.3-3.5,18.9-3.5,28.5C193.3,316.4,249.9,371.6,319.6,371.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path-13",
    className: "st3",
    d: "M616.8,329.5c-39-0.9-79.8-31.7-88.1-39.6c-21.4-19.8-71-73.6-74.7-77.9 c-36.4-40.5-85.6-86-134.2-86l0,0c-59.6,0.5-109.7,40.5-122.8,94.3c0.9-3.5,20.5-54.3,92.5-52.7c39,0.9,80.1,32.2,88.3,40 c21.4,19.8,71.1,73.6,74.8,77.9c36.3,40.5,85.3,86,134.2,86l0,0c57.5,0.2,107.9-38.5,122.6-94.1 C708.5,280.7,688.6,331.3,616.8,329.5z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 96,
    className: "st0",
    width: 800,
    height: 450
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDfinity);
export default __webpack_public_path__ + "static/media/Logo Dfinity.1adf36c050b117d49a9d1a29986c47ec.svg";
export { ForwardRef as ReactComponent };